import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';

import { MazFeedbackPayload } from '../models/maz-feedback';
import { ConversationHistory, MazMessage } from '../models/maz-message';
import { MazResponse } from '../models/maz-response';

@Injectable({
  providedIn: 'root',
})
export class MazChatService {
  private http = inject(HttpClient);

  private readonly api = '/api/maz/v1';

  getConversationHistory(): Observable<MazMessage[]> {
    return this.http
      .get<ConversationHistory>(`${this.api}/conversation_history`)
      .pipe(map(({ conversation_history }) => conversation_history));
  }

  sendMazMessage(userInput: string): Observable<MazResponse> {
    return this.http.post<MazResponse>(`${this.api}/process_message`, { userInput });
  }

  submitFeedback(body: MazFeedbackPayload): Observable<void> {
    return this.http.post<void>(`${this.api}/submit_feedback`, body);
  }
}
